import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { format } from "date-fns";
import { DateFormat, PayorInUseMessage } from "src/app/common/constants/core-constants";
import { ClientSideListBaseComponent } from "src/app/common/core/client-side-list-base/client-side-list-base.component";

@Component({
  selector: "app-payor-in-use",
  templateUrl: "./payor-in-use.component.html",
  styleUrls: ["./payor-in-use.component.scss"],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ClientSideListBaseComponent,
  ],
  standalone: true,
})
export class PayorInUseComponent {
  title: string = "Payor In Use ";
  message: string = PayorInUseMessage;
  inUsePlans: {
    patientname: string;
    facilityname: string;
    fromdate: string;
  }[] = [];
  columnDefinitions: ColDef[] = [
    {
      field: "facilityname",
      headerName: "Facility",
      sortable: true,
    },
    {
      field: "patientname",
      headerName: "Patient",
      sortable: true,
    },
    {
      field: "fromdate",
      headerName: "From Date",
      cellRenderer: (params: ICellRendererParams) => {
        return format(new Date(params.value), DateFormat);
      },
      sortable: true,
    },
  ];

  constructor(
    public dialog: MatDialogRef<PayorInUseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.inUsePlans = data.inUsePlans;
  }

  ngOnInit(): void {
    this.dialog.addPanelClass("custom-dialog-container");
  }
}
